// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1NpJY","footer":"ModalError_footer__3pO2d"};